import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';

const EditSidebarDiv = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 4px;
`;

export const EditSidebarCopy: FC = () => (
  <EditSidebarDiv>
    <Trans id="edit-sidebar-copy">Edit sidebar</Trans>
  </EditSidebarDiv>
);
